import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ToastrService } from "ngx-toastr";
import { TipoDeEquipamento } from "src/app/pages/domain/domain.model";
import { EquipamentoService } from "src/app/services/equipamento.service";
import { TipoEquipamentoService } from "src/app/services/tipo-equipamento.service";
import { ParametersPesquisaEquipamento } from "src/app/pages/domain/viewmodels.models";
import { SCAMP_API } from "src/environments/environment";

@Component({
  selector: "app-pesquisa-equipamento",
  templateUrl: "./pesquisa-equipamento.component.html",
  styleUrls: ["./pesquisa-equipamento.component.scss"],
})
export class PesquisaEquipamentoComponent implements OnInit, OnChanges {
  constructor(
    private equipamentoService: EquipamentoService,
    private modalService: NgbModal,
    private toastr: ToastrService,
    private tipoEquipamentoService: TipoEquipamentoService,
    private formBuilder: FormBuilder
  ) {}

  /* <VARIÁVEIS> -------------------------- */
  public tiposEquipamentos: TipoDeEquipamento[] = [];
  public filtredByTipo = 0;
  public filtredByParameter = "";
  public cadastrados: any[] = [];
  public isProcessing: boolean = false;

  public voids: string[] = [];
  public maxRowsVoids = 7;

  public idSelected: number = 0;

  public formPesquisa: FormGroup;

  @Input() public shouldOpenModal: boolean;
  @ViewChild("modaledit") modaledit: ElementRef;
  @Output() public EnviarEquipamento: EventEmitter<any> = new EventEmitter();

  public hasQrCode: boolean = false;
  /* </VARIÁVEIS> -------------------------- */

  ngOnInit() {
    this.getTiposEquipamentos();
    this.resetFormPesquisa();
  }

  resetFormPesquisa() {
    this.formPesquisa = this.formBuilder.group({
      parameter: [""],
      valor: ["", [Validators.required]],
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.shouldOpenModal != null) {
      if (changes.shouldOpenModal) {
        setTimeout(() => {
          this.setVoids();
          this.openModal();
        });
      }
    }
  }

  openModal() {
    this.modalService.open(this.modaledit, { windowClass: "xlModal" });
  }

  public getById(id: number, c: any): void {
    this.isProcessing = true;
    this.idSelected = id;

    this.equipamentoService.getById(id).subscribe(
      (response: any) => {
        this.EnviarEquipamento.emit(response);
        this.isProcessing = false;
        c("Close click");
      },
      (error: any) => {
        this.toastr.error(error);
      }
    );
  }

  private getTiposEquipamentos() {
    this.tipoEquipamentoService
      .getAll()
      .subscribe((response: TipoDeEquipamento[]) => {
        this.tiposEquipamentos = response;
      });
  }

  getVisivelNoSistema(tipoEquipamentoId) {
    return !this.tiposEquipamentos.some((t) => t.id == tipoEquipamentoId);
  }

  public setVoids(): void {
    this.voids = [];
    if (this.cadastrados.length < this.maxRowsVoids) {
      for (let i = this.cadastrados.length; i < this.maxRowsVoids; i++) {
        this.voids.push("");
      }
    }
  }

  submitPesquisa() {
    this.isProcessing = true;
    this.hasQrCode = false;

    this.equipamentoService
      .busca(this.formPesquisa.value as ParametersPesquisaEquipamento)
      .subscribe((response) => {
        this.cadastrados = response;
        this.setVoids();
        this.isProcessing = false;

        if (this.cadastrados.length == 0) {
          this.toastr.warning(
            "Nenhum resultado foi encontrado com os parâmetro fornecidos"
          );
        }
      });
  }

  gerarQrCode() {
    if (this.cadastrados) {
      this.hasQrCode = false;
      this.isProcessing = true;

      this.cadastrados.map((item) => {
        fetch(`${SCAMP_API.accountApiV1}/qrcode/equipamento/${item.id}`)
          .then((data) => data.json())
          .then((json) => {
            item.qrCodeName = `${
              SCAMP_API.pathDownloadQrCode
            }/${encodeURIComponent(json.qrCodeName)}`;
          })
          .catch(console.log);
      });

      this.hasQrCode = true;
      this.isProcessing = false;
    }
  }
}
